export const endpoints = {
  auth: {
    login: "/auth/login",
    forgotPassword: "/operator/forgot-password",
    resetPassword: "/operator/reset-password",
  },

  companies: {
    list: "/company",
    byId: (id) => `/company/${id}`,
    create: "/company",
  },

  operators: {
    createAdmin: "/operator/admin",
    list: "/operator",
    listAdmin: "/operator/admin/all",  
    create: "/operator",
    detail: (id) => `/operator/${id}`,
    update: (id) => `/operator/${id}`,
    toggle: (id) => `/operator/${id}/toggle`,
    clientProfile: (id) => `/operator/${id}/client-profile`,
  },

  rfidDevices: {
    list: "/rfid-device",
    byId: (id) => `/rfid-device/${id}`,
    create: "/rfid-device",
  },

  rfid_tag:{
    exportBySku: "/rfid-tag/export-epcs-by-sku",
  },
  
  warehouse: {
    list: "/warehouse",
    byId: (id) => `/warehouse/${id}`,
    create: "/warehouse",
    update: (id) => `/warehouse/${id}`,
    toggle: (id) => `/warehouse/${id}/toggle`,
    byCompany: (companyId) => `/warehouse/by-company/${companyId}`,
  },

  warehouseZone: {
    list: "/warehouse-zone",
    byId: (id) => `/warehouse-zone/${id}`,
    create: "/warehouse-zone",
    update: (id) => `/warehouse-zone/${id}`, 
    toggle: (id) => `/warehouse-zone/${id}/toggle`,
  },

  products: {
    list: "/product",
    byId: (id) => `/product/${id}`,
    create: "/product",
    toggle: (id) => `/product/${id}/toggle`,
    import: "/product/import",
  },

  productCategories: {
    list: "/product-category",
    byId: (id) => `/product-category/${id}`,
    create: "/product-category",
    toggle: (id) => `/product-category/${id}/toggle`,
  },

  stores: {
    list: "/store",
    byId: (id) => `/store/${id}`,
    create: "/store",
    update: (id) => `/store/${id}`,
    byCompany: (companyId) => `/store/by-company/${companyId}`,
  },

  inventory: {
    list: "/inventory",
    byWarehouse: "/inventory/warehouse",
    export: "/inventory/export/excel",
    byId: (id) => `/inventory/${id}`,
    create: "/inventory",
    update: (id) => `/inventory/${id}`,
    import: "/inventory/import",
  },

  movements: {
    list: "/movement",
    byId: (id) => `/movement/${id}`,
    create: "/movement",
    update: (id) => `/movement/${id}`,
    remove: (id) => `/super-admin/movement/${id}`,
    confirmRecount: (id) => `/movement/${id}/confirm-recount`,
    pendingConfirmation: "/movement/pending-confirmation",
    pendingReception: "/movement/pending-reception",
    cancel: (id) =>`/movement/${id}/cancel`,
  },

  users: {
    list: "/user",
    byId: (id) => `/user/${id}`,
    create: "/user",
  },

  clients: {
    list: "/client",
    byId: (id) => `/client/${id}`,
    create: "/client",
  },

  clientModules: {
    list: "/client-modules",
    byId: (id) => `/client-modules/${id}`,
    create: "/client-modules",
    update: (id) => `/client-modules/${id}`,
    toggle: (id) => `/client-modules/${id}/toggle`,
    remove: (id) => `/client-modules/${id}`,
  },

  suppliers: {
    list: "/suppliers",
    create: "/suppliers",
    byId: (id) => `/suppliers/${id}`,
    update: (id) => `/suppliers/${id}`,
    toggle: (id) => `/suppliers/${id}/toggle`,
  },

  externalClients: {
    list: "/external-client",
    create: "/external-client",
    byId: (id) => `/external-client/${id}`,
    update: (id) => `/external-client/${id}`,
    remove: (id) => `/external-client/${id}`,
  },

  alerts: {
    all: "/alerts/company",
    unresolved: "/alerts/company/unresolved",
    byWarehouse: "/alerts/company/warehouse",
    unresolvedByWarehouse: () => "/alerts/company/warehouse",
    allByWarehouse: () => "/alerts/company/warehouse",
    byId: (id) => `/alerts/${id}`,
    resolve: (id) => `/alerts/${id}/resolve`,
    summary: "/alerts/company/summary",
  },

  apk: {
    list: "/apk",
    latest: "/apk/latest",
  },
};
